import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { UtilsService } from './utils.service';
// import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  constructor( @Inject(PLATFORM_ID) platformId: any, private utils: UtilsService) {
    if (isPlatformBrowser(platformId)) {
      // this.checkVersion();
    }
  }

  checkForUpdate() {
    // if (this.updates.isEnabled) {
    //   this.updates.checkForUpdate();
    // }
  }

  // checkVersion() {
  //   if (this.updates.isEnabled) {
  //     this.updates.versionUpdates.subscribe((event: any) => {
  //       if (event.type.toLowerCase() == 'version_detected') {
  //         this.utils.showForceUpdate.next(true);
  //       }
  //     })
  //   }
  // }


  activateUpdate() {
    // this.updates.activateUpdate().then(() => {
    //   window.location.reload();
    // });
  }
}
